import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { elements } from '@ecosystem/newron-design-system';
import { PageType } from '@utils/pageConfig/Types';
import { FC, memo } from 'react';

const { Icon } = elements;
const { Info } = Icon.icons;

interface NoComparisonPeriodProps {
  pageType: PageType;
  periodicity: Periodicity;
}

const NoComparisonPeriod: FC<NoComparisonPeriodProps> = ({ pageType, periodicity }) => {
  if (![PageType.RI_PRODUCT].includes(pageType) || ![Periodicity.YTD, Periodicity.MAT].includes(periodicity)) {
    return null;
  }

  return (
    <div className="p-6 text-base flex bg-brand-light">
      <Icon color="info">
        <Info />
      </Icon>
      <div className="ml-2">
        Items not sold in latest period aggregated to Others. No Comparison period possible - growth rates not shown
      </div>
    </div>
  );
};

export default memo(NoComparisonPeriod);
